// Injeção do código base do Google Analytics
export const appendGoogleAnalyticsTrackingCode = () => {
  try {
    const scriptBaseOne = window.document.createElement('script');
    scriptBaseOne.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.NEXT_PUBLIC_GA_TOKEN}`;
    scriptBaseOne.async = true;

    const scriptBaseTwo = document.createElement('script');
    scriptBaseTwo.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${process.env.NEXT_PUBLIC_GA_TOKEN}');
        `;

    document.head.appendChild(scriptBaseOne);
    document.head.appendChild(scriptBaseTwo);
  } catch (error) {
    console.error('Erro ao injetar analytics:', error);
  }
};
